export function removeId<T extends { id: string }>(
  items: T[],
  idToRemove: string,
): T[] {
  if (!items) return [];
  return items.filter((x) => x.id !== idToRemove);
}
